<template>
  <div class="h-pm-gnb-dataQuery-tree">
    <ejs-listview
      ref="reportTask"
      :dataSource="taskDatas"
      :fields="fieldsReportTaskName"
      :select="nodeSelectedOfTaskId"
    ></ejs-listview>
  </div>
</template>

<script>
export default {
  name: "PmReportGnbDataLeft",
  components: {},
  data() {
    return {
      taskDatas: [],
      fieldsReportTaskName: {
        text: "name",
        tooltip: "name",
        id: "id"
      }
    };
  },
  methods: {
    nodeSelectedOfTaskId(args){
      this.$emit('reportGnbDataClickEventPush', args.data);

    },
    getReportTaskData() {
      const This = this;
      This.$axios
        .get(`/lte/ems/pm/gnb/report/task/queryReportTask`)
        .then(reportTaskInfos => {
          const reportTaskData = reportTaskInfos.data.resultVal;        
          This.taskDatas = reportTaskData;
        });
    }
  },
  created() {
    this.getReportTaskData();
  }
};
</script>

<style>
</style>
